import React, { useEffect } from 'react';

import { useRecoilValue } from 'recoil';
import {
  classesState,
  classesStateType,
} from 'state';
import styled from 'styled-components';

interface MainContainerProps {
    children: React.ReactNode
}

const MainContainer:React.FC<MainContainerProps> = ({children}) => {
  const selected = useRecoilValue(classesState(classesStateType.CREATE_MENU));

  useEffect(()=>{
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
  },[selected])

return(
  <Container>
    {children}
  </Container>
)

}
export { MainContainer };

const Container = styled.div`
    width: 100%;      
    flex: 1;
    height: calc(100vh) ;
    padding-bottom: 100px;
    overflow-y: scroll;
    scrollbar-width: 8px;
    scroll-behavior: smooth;
    scrollbar-color: #33333320 transparent;
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #333;
    }
`;
const Header = styled.div`
 
`; 

